import * as yup from 'yup';
import { error } from '../text';

export const evaluationSendSchema = yup.object().shape({
  nickname: yup.string().max(250, error.below250).required(error.required),
  title: yup.string().max(250, error.below250).required(error.required),
  content: yup.string().max(250, error.below250).required(error.required)
});
